import { createSlice } from '@reduxjs/toolkit'
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    [config.storageTokenKeyName]: null   // access_token vive solo en memoria
  },
  reducers: {
    handleLogin: (state, action) => {
      const data = { ...action.payload }
      // Solo borramos los tokens — id y role quedan en localStorage para el startup refresh
      delete data.access_token
      delete data.refresh_token
      delete data.accessToken
      delete data.refreshToken
      delete data.ability

      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]

      localStorage.setItem('userData', JSON.stringify(data))
      // access_token NO se guarda en localStorage
    },
    handleRefreshToken: (state, action) => {
      state[config.storageTokenKeyName] = action.payload
      if (state.userData) state.userData[config.storageTokenKeyName] = action.payload
      // NO se persiste en localStorage — solo en memoria
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      localStorage.clear()
    }
  }
})

export const { handleLogin, handleRefreshToken, handleLogout } = authSlice.actions

export default authSlice.reducer
